"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _formatNumber = _interopRequireDefault(require("../utils/formatNumber"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(value) {
  if (value === '__missing__') {
    return 'No Data';
  }

  return (0, _formatNumber["default"])(value);
};

exports["default"] = _default;